import { prefixObjectValues } from '../../utils';
const wizard = {
  basicInfoStep: 'basic-info-step',
  facilitiesStep: 'facilities-step',
  laborMetricsStep: 'labor-metrics-step',
  compensationStep: 'compensation-step',
  shiftDetailsStep: 'shift-details-step',
  onCallShiftDetailsStep: 'on-call-shift-details-step',
  costCalculatorStep: 'cost-calculator-step',
  additionalInfoStep: 'additional-info-step',
  reviewStep: 'review-step',
  primaryBtn: 'primary-btn',
  secondaryBtn: 'secondary-btn',
  backBtn: 'back-btn',
  cancelBtn: 'cancel-btn',
};
export default prefixObjectValues(wizard, 'wizard');
